import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react'
import checkIcon from "./img/check.png";
import "./styles/MultiSelectOptions.scss";
import { FormattedMessage, useIntl } from 'react-intl';
import useCapitalizedLetters from 'scenes/ProjectMultiStepForm/hooks/useCapitalizedLetters';

const MultiSelectOptions = ({ 
  selectValues,
  selectedOptions,
  loading,
  disabledPlaceholder,
  handleClickCurrentOption,
  onFilterChange,
  handlerCreateProvider,
  withoutCreateProvider
}) => {
  const intl = useIntl();
  const searchInputRef = useRef(null);
  const [listValues, setListValues] = useState(selectValues);
  const debounceTimeout = useRef(null);
  const [filterSearch, setFilterSearch] = useState('');

  const handlerDebounceToFilter = (callback, delay) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      callback();
    }, delay);
  };

  const handleProductFilter = (e) => {
    const { name, value } = e.target;
    setFilterSearch(value);

    handlerDebounceToFilter(() => onFilterChange(value), 1000)
  };

  useEffect(() => {
    setListValues(selectValues);
  }, [selectValues]);

  useEffect(() => {
    searchInputRef.current.focus(); /* Auto focus search input */
  }, [])

  return (
    <div className="multi-options bg-white p-3 mt-1">
      <input
        type="text"
        ref={searchInputRef}
        name='filter-search'
        alt="filter-search"
        value={filterSearch}
        placeholder={intl.formatMessage({ id: "ProductsMultiSelect.search" })}
        onChange={handleProductFilter}
        className="multi-options__search col-12 mb-2 px-1 border-top-0 border-left-0 border-right-0 border-bottom"
      />
      {!loading ? (
        listValues.length > 0 ? (
          listValues?.map(({ id, label, value }, index) => (
            <div
              key={id}
              className={classNames({
                "select__current-option d-flex align-items-center": true,
                "select__current-option-with-border":
                  index !== listValues.length - 1,
              })}
              onClick={handleClickCurrentOption({ label, value })}
            >
              <span
                className={classNames({
                  "check-option border border-dark rounded-circle d-flex align-items-center justify-content-center p-2 mr-1": true,
                  "check-option-selected": selectedOptions.some(
                    (option) => option.label === label
                  ),
                })}
                onClick={handleClickCurrentOption({ label, value })}
              >
                <img src={checkIcon} alt="check-icon" width={10} height={10} />
              </span>
              {label}
            </div>
          ))
        ) : withoutCreateProvider ? "No hay resultados..." : (
          <button
            type="button"
            className="step-0-form__submit-btn create-provider_btn px-3 py-1 mt-2"
            onClick={handlerCreateProvider}
          >
            <FormattedMessage
              id="ProjectStepForm.button.createProvider"
              defaultMessage="Crear proveedor"
            />
          </button>
        )
      ) : (
        disabledPlaceholder
      )}
    </div>
  );
}

export default MultiSelectOptions;
